import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoClientsGetRes } from "./abst/DtoClientsGetRes";

export class DtoClientsGetResImple extends DtoClientsGetRes {
  public pager = new DtoApiPager();
}
